export const MAX_AVATAR_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_AVATAR_FILE_MB = 5;
